import PersonOutline from "@mui/icons-material/PersonOutline";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import AppShortcutIcon from "@mui/icons-material/AppShortcut";
import { Money, Settings, LocalOffer, History } from "@mui/icons-material";

import { IMenuData } from "./types";

import ROUTE_CONSTANTS from "@/constants/route-constants";
const menuData: IMenuData[] = [
    {
        id: 1,
        title: "User Management",
        icon: <PersonOutline />,
        href: ROUTE_CONSTANTS.USER_MANAGEMENT.ROOT.ABSOLUTE,
        permission: {
            page: ["user", "customer", "institution"],
            access: "List",
        },
        children: [
            {
                id: 11,
                title: "Users",
                href: ROUTE_CONSTANTS.USER_MANAGEMENT.USERS.ROOT.ABSOLUTE,
                permission: {
                    page: "user",
                    access: "List",
                },
            },
            {
                id: 12,
                title: "Customers",
                href: ROUTE_CONSTANTS.USER_MANAGEMENT.CUSTOMERS.ROOT.ABSOLUTE,
                permission: {
                    page: "customer",
                    access: "List",
                },
            },
            {
                id: 13,
                title: "Institutions",
                href: ROUTE_CONSTANTS.USER_MANAGEMENT.INSTITUTIONS.ROOT.ABSOLUTE,
                permission: {
                    page: "institution",
                    access: "List",
                },
            },
        ],
    },
    {
        id: 3,
        title: "Media Management",
        icon: <OndemandVideoIcon />,
        href: ROUTE_CONSTANTS.MEDIA_MANAGEMENT.ROOT.ABSOLUTE,
        permission: {
            page: ["image", "video", "avatar"],
            access: "List",
        },
        children: [
            {
                id: 32,
                title: "Images",
                href: ROUTE_CONSTANTS.MEDIA_MANAGEMENT.IMAGES.ROOT.ABSOLUTE,
                permission: {
                    page: "image",
                    access: "List",
                },
            },
            {
                id: 31,
                title: "Videos",
                href: ROUTE_CONSTANTS.MEDIA_MANAGEMENT.VIDEOS.ROOT.ABSOLUTE,
                permission: {
                    page: "video",
                    access: "List",
                },
            },
            {
                id: 33,
                title: "Avatars",
                href: ROUTE_CONSTANTS.MEDIA_MANAGEMENT.AVATARS.ROOT.ABSOLUTE,
                permission: {
                    page: "avatar",
                    access: "List",
                },
            },
        ],
    },
    {
        id: 2,
        title: "Content Management",
        icon: <NewspaperIcon />,
        href: ROUTE_CONSTANTS.CONTENT_MANAGEMENT.ROOT.ABSOLUTE,
        permission: {
            page: ["tag", "genre", "publisher", "content"],
            access: "List",
        },
        children: [
            {
                id: 22,
                title: "Tags",
                href: ROUTE_CONSTANTS.CONTENT_MANAGEMENT.TAGS.ROOT.ABSOLUTE,
                permission: {
                    page: "tag",
                    access: "List",
                },
            },
            {
                id: 23,
                title: "Genres",
                href: ROUTE_CONSTANTS.CONTENT_MANAGEMENT.GENRES.ROOT.ABSOLUTE,
                permission: {
                    page: "genre",
                    access: "List",
                },
            },
            {
                id: 24,
                title: "Publisher",
                href: ROUTE_CONSTANTS.CONTENT_MANAGEMENT.CONTENTS.SHOW_PUBLISHER.ROOT.ABSOLUTE,
                permission: {
                    page: "publisher",
                    access: "List",
                },
            },
            {
                id: 21,
                title: "Contents",
                href: ROUTE_CONSTANTS.CONTENT_MANAGEMENT.CONTENTS.ROOT.ABSOLUTE,
                permission: {
                    page: "content",
                    access: "List",
                },
            },
        ],
    },
    {
        id: 4,
        title: "App UI Management",
        icon: <AppShortcutIcon />,
        href: ROUTE_CONSTANTS.APP_UI_MANAGEMENT.ROOT.ABSOLUTE,
        permission: {
            page: "ui_home",
            access: "List",
        },
        children: [
            {
                id: 41,
                title: "Home Page",
                href: ROUTE_CONSTANTS.APP_UI_MANAGEMENT.HOME.ROOT.ABSOLUTE,
                permission: {
                    page: "ui_home",
                    access: "List",
                },
            },
            {
                id: 42,
                title: "Category Selector",
                href: ROUTE_CONSTANTS.APP_UI_MANAGEMENT.CATEGORY_SELECTOR.ROOT.ABSOLUTE,
                permission: {
                    page: "ui_home",
                    access: "Update",
                },
            },
        ],
    },
    {
        id: 6,
        title: "transactions",
        icon: <Money />,
        href: ROUTE_CONSTANTS.TRANSACTIONS.ROOT.ABSOLUTE,
        permission: {
            page: [],
            access: "List",
        },
    },
    {
        id: 7,
        title: "Admin History",
        icon: <History />,
        href: ROUTE_CONSTANTS.ADMIN_LOGS.ROOT.ABSOLUTE,
        permission: {
            page: [],
            access: "List",
        },
    },

    {
        id: 5,
        title: "Settings",
        icon: <Settings />,
        href: ROUTE_CONSTANTS.SETTINGS.ROOT.ABSOLUTE,
        permission: {
            page: ["static", "country", "plans", "coupon"],
            access: "List",
        },
        children: [
            {
                id: 51,
                title: "Static Page",
                href: ROUTE_CONSTANTS.SETTINGS.STATIC.ROOT.ABSOLUTE,
                permission: {
                    page: "static",
                    access: "List",
                },
            },
            {
                id: 52,
                title: "Country & Currency",
                href: ROUTE_CONSTANTS.SETTINGS.COUNTRIES.ROOT.ABSOLUTE,
                permission: {
                    page: "country",
                    access: "List",
                },
            },
            {
                id: 53,
                title: "Plans",
                href: ROUTE_CONSTANTS.SETTINGS.PLANS.ROOT.ABSOLUTE,
                permission: {
                    page: "plans",
                    access: "List",
                },
            },
            {
                id: 54,
                title: "Coupons",
                href: ROUTE_CONSTANTS.SETTINGS.COUPONS.ROOT.ABSOLUTE,
                permission: {
                    page: "coupon",
                    access: "List",
                },
            },
            {
                id: 55,
                title: "Currency Exchange",
                href: ROUTE_CONSTANTS.SETTINGS.CURRENCY_EXCHANGE.ROOT.ABSOLUTE,
                permission: {
                    page: "country",
                    access: "Update",
                },
            },
        ],
    },
];

export default menuData;
